// extracted by mini-css-extract-plugin
export default {"mainText":"UserModal_mainText__nyQjx","btnCustom":"UserModal_btnCustom__0WcQc","page":"UserModal_page__DUkto","inp":"UserModal_inp__sfhFG"};